<template>
  <div>
    <transition name="fade">
      <router-view
        v-if="getUserRole() === 'admin'" />
    </transition>
    <ErrorMessageUserContainer
      v-if="error"
      :error="error"
    />
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import ErrorMessageUserContainer from './ErrorMessageUserContainer.vue';

export default {
  data() {
    return {
      error: null,
    };
  },
  components: {
    ErrorMessageUserContainer,
  },
  computed: {
    ...mapGetters(['currentUser']),
  },
  created() {
    this.checkPermission();
  },
  watch: {
    currentUser() {
      this.checkPermission();
    },
  },
  methods: {
    getUserRole() {
      return _.get(this.currentUser, 'roleId', '');
    },
    checkPermission() {
      if (this.getUserRole() !== 'admin') {
        this.error = {
          status: 403,
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
